export default {
  data() {
    const typeList = [
      {
        text: '企业基本信息',
        value: 1,
      },
      {
        text: '企业主要联系人',
        value: 2,
      },
      {
        text: '企业额外信息',
        value: 3,
      },
      {
        text: '企业外部评分信息',
        value: 4,
      },
      {
        text: '评分卡财报数据',
        value: 5,
      },
      {
        text: '企业账户信息',
        value: 6,
      },
      {
        text: '担保及保险',
        value: 7,
      },
      {
        text: '融资数据',
        value: 8,
      },
    ]
    return {
      searchSchema: [
        {
          label: '文件名称',
          type: 'input',
          itemName: 'fileName',
          allowClear: true,
        },
        {
          label: '文件类型',
          type: 'select',
          itemName: 'type',
          allowClear: true,
          selectList: typeList,
        },
        {
          label: '上传日期',
          type: 'rangePicker',
          itemName: 'date',
          format: 'YYYY-MM-DD',
          allowClear: true,
        },
      ],
      searchForm: {
        date: [],
      },
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      tableData: [],
      tableColumns: [
        {
          fixed: 'left',
          title: '序号',
          width: 70,
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
        },
        {
          title: '文件名称',
          width: 210,
          dataIndex: 'fileName',
        },
        {
          title: '文件类型',
          width: 200,
          scopedSlots: { customRender: 'type' },
        },
        {
          title: '上传时间',
          width: 220,
          dataIndex: 'createTime',
        },
        {
          title: '上传操作人',
          width: 180,
          dataIndex: 'user',
        },
        {
          title: '操作',
          width: 80,
          fixed: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ],
    }
  },
  methods: {
    // 查询
    handleSearch(data) {
      this.searchForm = { ...this.searchForm, ...data }
      this.pageData.current = 1
      this._getTableData()
    },
    // 点击分页按钮
    handleClickPage({ current, pageSize }) {
      this.pageData = { ...this.pageData, current, pageSize }
      this._getTableData()
    },
  },
}
